import { ItemRequest } from '../../models/dashboard-models';
import { useTranslation } from 'react-i18next';
import { Spinner, Table } from 'react-bootstrap';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';

export const MissingItemsForTasks = ({
    missingItems,
    userId,
    isLoadingMissingItems = false,
}: {
    missingItems: ItemRequest[];
    userId?: string;
    isLoadingMissingItems?: boolean;
}) => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });

    return userId && isLoadingMissingItems ? (
        <div className='w-100 p-2 d-flex flex-column align-items-center gap-2'>
            <h5 className='mb-0'>
                {t('missingItems')} <FontAwesomeIcon icon={faExclamationTriangle} color='red' />
            </h5>
            <Spinner animation='border' />
        </div>
    ) : userId && missingItems && missingItems.length > 0 ? (
        <div className='w-100 p-2'>
            <h5>{t('missingItems')} <FontAwesomeIcon icon={faExclamationTriangle} color='red' /></h5>
            <Table striped hover responsive className='mt-2 border border-dark'>
                <thead>
                    <tr>
                        <th className='fw-bold w-25 text-center'>{t('materials')}</th>
                        <th className='fw-bold w-25 text-center'>{t('type')}</th>
                        <th className='fw-bold w-25 text-center'>{t('quantity')}</th>
                    </tr>
                </thead>
                <tbody>
                    {missingItems.map((item, index) => (
                        <tr key={index}>
                            <td className='text-center'>{item.itemName}</td>
                            <td className='text-center'>{t(item.itemType.toLowerCase())}</td>
                            <td className='text-center'>{item.itemCount}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    ) : (
        <></>
    );
};
